import { FormattedMessage } from 'react-intl';
import { NavItemType } from 'types/menu';
import { GoWorkflow } from 'react-icons/go';
import { GrDatabase } from 'react-icons/gr';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { MdDelete, MdOutlinePublic } from 'react-icons/md';
import { IoHomeOutline } from 'react-icons/io5';

import { dataPagePath, welcomePagePath, workflowDatasetsPagePath, workflowsPath } from 'routes/paths';
const icons = {
    GoWorkflow: GoWorkflow as React.ElementType,
    GrDatabase: GrDatabase as React.ElementType,
    FaCloudUploadAlt: FaCloudUploadAlt as React.ElementType,
    MdDelete: MdDelete as React.ElementType,
    MdOutlinePublic: MdOutlinePublic as React.ElementType,
    IoHomeOutline: IoHomeOutline as React.ElementType,
};

const menu: NavItemType = {
    id: 'menu',
    type: 'group',
    children: [
        {
            id: 'home',
            title: <FormattedMessage id='home' />,
            type: 'item',
            url: welcomePagePath(),
            icon: icons.IoHomeOutline,
        },
        {
            id: 'datasets',
            title: <FormattedMessage id='datasets' />,
            type: 'collapse',
            icon: icons.GrDatabase,
            children: [
                {
                    id: 'uploadDataSets',
                    title: <FormattedMessage id='uploadDataSets' />,
                    type: 'item',
                    url: dataPagePath(),
                    icon: icons.FaCloudUploadAlt,
                },
                {
                    id: 'workflowDataSets',
                    title: <FormattedMessage id='workflowDataSets' />,
                    type: 'item',
                    url: workflowDatasetsPagePath(),
                    icon: icons.GoWorkflow,
                },
            ],
        },
        {
            id: 'workflows',
            title: <FormattedMessage id='workflows' />,
            type: 'item',
            url: workflowsPath(),
            icon: icons.GoWorkflow,
        },
    ],
};

export default menu;
